module.exports = __webpack_public_path__ + "static/media/5ece317501f347edab70db7d.78e171bf.png";